import { message } from 'antd';
import { put, takeLatest, select } from 'redux-saga/effects';
import { TaskType } from 'api/tasks';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  UpdateTaskInProjectTemplate,
  updateTaskInProjectTemplate,
} from '../../actions';
import { selectTemplateTask } from '../../selectors';
import { updateProjectTemplateTask } from '../../slices';
import { ProjectTemplateTask } from '../../types';

function* updateTaskInTemplateSaga(
  action: StoreActionProps<UpdateTaskInProjectTemplate>,
) {
  try {
    const {
      payload: { taskId, payload },
    } = action;

    const task: ProjectTemplateTask = yield select(selectTemplateTask(taskId));
    const newTask = !task.taskName;

    try {
      const currentFields =
        task?.fields && task?.fields.length > 0
          ? payload.fields && payload.fields?.length > 0
            ? task?.fields?.filter(
                (f) =>
                  !payload.fields?.map((x) => x.fieldId).includes(f.fieldId),
              )
            : task.fields
          : [];

      yield put(
        updateProjectTemplateTask({
          task: {
            ...task,
            ...payload,
            fields:
              payload?.fields && payload?.fields.length > 0
                ? [...currentFields, ...payload.fields]
                : currentFields,
            ...{
              isCsatEnabled:
                payload.isCsatEnabled === undefined
                  ? payload.type === TaskType.Milestone
                    ? true
                    : payload.type === TaskType.Task
                    ? false
                    : task.isCsatEnabled
                  : payload.isCsatEnabled,
            },
          },
          updatePrivacyOfChildren: payload.private != null,
          isNew: newTask,
        }),
      );
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      yield put(
        updateProjectTemplateTask({
          task: {
            ...task,
            ...payload,
            ...{
              isCsatEnabled:
                payload.isCsatEnabled === undefined
                  ? payload.type === TaskType.Milestone
                    ? true
                    : payload.type === TaskType.Task
                    ? false
                    : task.isCsatEnabled
                  : payload.isCsatEnabled,
            },
          },
          updatePrivacyOfChildren: payload.private != null,
          isNew: newTask,
        }),
      );
    }

    /**
     * Commenting out old date shift logic code
     * TODO: to be removed after thorough code walk through.
     */

    // if (payload.duration || payload.startDay) {
    //   yield put(updateProjectTemplateStartdayDuration({ taskId }));
    // }
  } catch (error) {
    logger.error('updateProjectTemplateTask failed', { error });

    message.error('There was an error updating the task');
  }
}

export function* watchUpdateTaskInProjectTemplateSaga(): Generator {
  yield takeLatest(updateTaskInProjectTemplate.type, updateTaskInTemplateSaga);
}
